/**
 * @fileoverview Vuex mutations for Watson Assistant state management.
 *
 * @module store/modules/watson/mutations
 *
 * Handles synchronous state updates for:
 * - Intents list
 * - Entities list
 * - Dialog nodes list
 * - Workspace configuration
 * - Edit tracking flags
 */

import { MutationTree } from "vuex/types";

import { WatsonState } from "./types";
import _ from "lodash";

const mutations: MutationTree<WatsonState> = {
  /**
   * Sets the Watson intents list.
   *
   * @param payload - Array of Watson intents
   */
  SET_WATSON_INTENT(state, payload) {
    state.intents = payload;
  },
  /**
   * Sets the Watson entities list.
   *
   * @param payload - Array of Watson entities
   */
  SET_WATSON_MY_ENTITIES(state, payload) {
    state.entities = payload;
  },
  /**
   * Sets the Watson dialog nodes list.
   *
   * @param payload - Array of dialog nodes
   */
  SET_WATSON_DIALOG_NODES(state, payload) {
    state.dialogNodes = payload;
  },

  /**
   * Sets the Watson workspace configuration.
   *
   * @param payload - Workspace configuration object
   */
  SET_WATSON_WORKSPACE(state, payload) {
    state.workspace = payload;
  },
  /**
   * Tracks which node types have unsaved edits.
   *
   * @param nodeVariableType - Type of node (intent, entity, dialog)
   * @param isEdited - Whether there are unsaved changes
   */
  SET_WATSON_IS_EDITED_OBJECT(state, { nodeVariableType, isEdited }) {
    const newisEditedObject = _.cloneDeep(state.isEditedObject);
    newisEditedObject[nodeVariableType] = isEdited;
    state.isEditedObject = newisEditedObject;
  },
};

export default mutations;
